import { Box, Button, DialogActions, DialogContent, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { Fragment, useState } from "react";
import { COMMOM_STATUS, EXPORT_TYPE, EXPORT_TYPE_TRANSLATETRANSLATE, orderStatusFormatted, PRINT_SIZE } from "src/constant";
import DeliveredReceipt from "./export-form/DeliveredReceipt";
import useOrderPreview from "src/hooks/orders/useOrderPreview";
import { enqueueSnackbar } from "notistack";
import useOrderPrint from "src/hooks/orders/useOrderPrint";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import appConfig from "src/config/env";
const exportType = [EXPORT_TYPE.WarehouseExport, EXPORT_TYPE.DeliveredReceipt];

export default function OrderDetailDialog({ id, whouseId }) {
  const [exportTypePick, setExportTypePick] = useState(EXPORT_TYPE.WarehouseExport);
  const [logId, setLogId] = useState();
  const { data: orderPreview, isLoading } = useOrderPreview(id, {
    warehouse: whouseId,
    outputFile: exportTypePick,
  });
  const { mutate } = useProcessLogDetail(logId, {
    warehouse: whouseId,
  });
  const { trigger: printAll } = useOrderPrint();

  const handlePrint = async () => {
    const res = await printAll({
      body: {
        orderIds: [id],
        pageSize: PRINT_SIZE.a6,
        warehouse: whouseId,
        outputFiles: [exportTypePick],
      },
    });
    if (res?.success) {
      setLogId(res?.data?._id);
      handleGetLog(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: "notistack-confirm" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? res?.error?.message, {
        variant: "error",
      });
    }
  };

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;
    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  return (
    <Fragment>
      <DialogContent>
        <Box sx={{ borderBottom: "1px solid var(--grey)", mb: "24px" }}>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={EXPORT_TYPE.WarehouseExport}
              name="radio-buttons-group"
              sx={{ flexDirection: "row" }}
              onChange={(e) => setExportTypePick(e.target.value)}
            >
              {exportType.map((v) => {
                return (
                  <FormControlLabel
                    key={v}
                    value={v}
                    control={<Radio />}
                    label={
                      [orderStatusFormatted.Pending, orderStatusFormatted.WaitToProcess, orderStatusFormatted.WaitToExport]?.includes(v)
                        ? "Thông tin xuất kho"
                        : EXPORT_TYPE_TRANSLATETRANSLATE[v]
                    }
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        </Box>
        <Box
          mt="24px"
          sx={{
            maxWidth: exportTypePick === EXPORT_TYPE.DeliveredReceipt ? PRINT_SIZE.width : "100%",
            maxHeight: exportTypePick === EXPORT_TYPE.DeliveredReceipt ? PRINT_SIZE.height : "100%",
            width: exportTypePick === EXPORT_TYPE.DeliveredReceipt ? "90%" : "100%",
            m: "0 auto",
          }}
        >
          <DeliveredReceipt
            isLoading={isLoading}
            html={orderPreview}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: "24px" }}>
        <Button
          onClick={handlePrint}
          fullWidth
          variant="contained"
        >
          In đơn hàng
        </Button>
      </DialogActions>
    </Fragment>
  );
}
